import { useMemo } from 'react';
import CheckmarkBackgroundIcon from '../images/checkmark-background-purple.svg';
import CheckMarkGreenIcon from '../images/checkmark-green.svg';
import Example1 from '../images/example-1.png';
import Example2 from '../images/example-2.png';
import Example3 from '../images/example-3.png';
import Example4 from '../images/example-4.png';
import Example5 from '../images/example-5.png';
import HintIcon from '../images/hint.svg';
import InfoIcon from '../images/info.svg';
import MicIcon from '../images/mic.svg';
import ThumbUpIcon from '../images/thumb-up.svg';
import TranslateIcon from '../images/translate.svg';
import TutorialIcon from '../images/tutorial.svg';
import VolumeIcon from '../images/volume.svg';
import GreenCircleIcon from '../images/circle-green.svg';
import YellowCircleIcon from '../images/circle-yellow.svg';
import { useLanguageData } from '@/common/hooks/useLanguageData';

export const useTutorialStages = () => {
	const langData = useLanguageData('features.sceneV3');

	return useMemo(
		() => [
			{
				image: Example1,
				items: [
					{
						icon: ThumbUpIcon,
						text: langData.clickToShareOpinion,
					},
					{
						icon: TutorialIcon,
						text: langData.clickToShownInstructions,
					},
					{
						icon: CheckmarkBackgroundIcon,
						text: langData.clickToCheckTasks,
					},
				],
			},
			{
				image: Example2,
				items: [
					{
						icon: VolumeIcon,
						text: langData.clickToHearAgain,
					},
					{
						icon: TranslateIcon,
						text: langData.clickToShowTranslation,
					},
					{ icon: HintIcon, text: langData.clickToShowHint },
					{ icon: InfoIcon, text: langData.clickToReportAProblem },
				],
			},
			{
				image: Example3,
				items: [
					{
						icon: GreenCircleIcon,
						text: langData.yourAnswerIsCorrect,
					},
					{
						icon: YellowCircleIcon,
						text: langData.clickToShowCorrectAnswer,
					},
				],
			},
			{
				image: Example4,
				items: [
					{
						text: langData.clickInTheTextInput,
					},
					{
						icon: MicIcon,
						text: langData.clickToStartRecording,
					},
				],
			},
			{
				image: Example5,
				items: [
					{
						icon: CheckMarkGreenIcon,
						text: langData.taskCompleted,
					},
					{
						text: langData.whenAllTasksAreDone,
					},
				],
			},
		],
		[langData],
	);
};
